// Payment requests (backend router/paymentRequests.js, admin only).
import { serviceConsumer } from '../../network/ServiceConsumer';

const BASE = () => `${process.env.REACT_APP_BASE_URL}/payment-requests/admin`;

export const listRequests = (params) => serviceConsumer('GET', BASE(), params);
export const getRequest = (id) => serviceConsumer('GET', `${BASE()}/${id}`);
export const searchOrganizers = (q) => serviceConsumer('GET', `${BASE()}/organizers`, { q });
export const organizerEvents = (organizerId) => serviceConsumer('GET', `${BASE()}/events`, { organizer_id: organizerId });
export const searchPayers = (q) => serviceConsumer('GET', `${BASE()}/payers`, { q });
export const createRequest = (payload) => serviceConsumer('POST', BASE(), payload);
export const resendRequest = (id) => serviceConsumer('POST', `${BASE()}/${id}/resend`);
export const cancelRequest = (id) => serviceConsumer('POST', `${BASE()}/${id}/cancel`);
export const resendReceipt = (id) => serviceConsumer('POST', `${BASE()}/${id}/resend-receipt`);
